var React = require('react');

function CheckCircleGray (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"22","cy":"22","r":"21","key":0}),React.createElement("path",{"fill":"#fff","d":"M18.4 23.6l-6-3.6-2.4 2.4 8.4 9.6L34 16.4 31.6 14z","key":1})]);
}

CheckCircleGray.defaultProps = {"viewBox":"0 0 46 46"};

module.exports = CheckCircleGray;

CheckCircleGray.default = CheckCircleGray;
